<!--
图片卡片
source，图片的地址
info，图片的介绍文字
-->
<template>
  <div id="imageCard">
    <el-card class="box-card" :body-style="{ padding: '0px',border:'none' }">
      <el-image :src="source"  fit="cover" class="image" :previewSrcList="[source]">
        <div slot="error" class="image-slot" >
          <img src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png" class="image" alt="">
        </div>
      </el-image>
      <div style="padding: 7px 14px;">
        <span>{{info?info:'默认文字'}}</span>
        <i class="el-icon-close" id="closeIcon" @click="close"></i>
        <div class="bottom clearfix">
        </div>
      </div>
    </el-card>
  </div>

</template>

<script>
export default {
  name: "imageCard",
  props:['source','info'],
  data(){
    return {

    }
  },
  methods:{
    close(){
      this.$emit('onClose',this.source);
    }
  },
  watch:{
    cardSize(val){
      switch (val) {
        case 'large':
          this.factor = 3;
          break;
        case 'medium' :
          this.factor =2;
          break;
        case 'small' :
          this.factor =1;
          break;
      }
    }
  }
}
</script>

<style scoped>
#imageCard{
  height: fit-content;
  display: block;
}
.box-card{
  border-radius: 7px!important;
  width: fit-content;
  height: fit-content;
  max-height: 100%;
}
#closeIcon{
  padding: 0;
  float: right;
  position: relative;
  bottom: -5px;
}
#closeIcon:hover{
  color: black;
  font-weight: bold;
}
.image{
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  max-height: 365px;
  object-fit: cover;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
</style>
